import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {Store} from '@ngrx/store';
import {loadGlobalConfig} from './global-config.actions';
import {selectGlobalConfigState} from './global-config.selectors';
import {filter, take} from 'rxjs/operators';

export const globalConfigResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);
  store.select(selectGlobalConfigState).pipe(
    take(1)
  ).subscribe(state => {
    if (!state.loaded) {
      store.dispatch(loadGlobalConfig());
    }
  });
  return true;
};
